<style lang="stylus">
@import '../../../stylesheet/variable.styl';
@import '../../../stylesheet/view/preorder.styl';
</style>
<style lang="less" scoped>
.preorder {
  background-color: #fff;
  min-height: 100vh;
  overflow: auto;
  padding: 23px 0 0px;
  .header-line {
    width: 100%;
    display: block;
  }
  .preorder-pay {
    position: fixed;
    bottom: 0;
    border-top: 1px solid #d2d2d2;
    width: 100%;
    display: flex;
    height: 44px;
    line-height: 44px;
    justify-content: flex-end;
    .ensure-btn {
      width: 140px;
      height: 44px;
      line-height: 44px;
      background-image: linear-gradient(283deg, #ff396d, #ff7232);
      color: #fff;
      text-align: center;
      font-size: 17px;
    }
    .can-not-buy {
      background-color: #999;
      background-image: none;
    }
    .need-pay {
      padding: 0 20px;
      font-size: 17px;
      color: #4a4a4a;
      height: 44px;
      line-height: 44px;
      span {
        color: #ff5000;
      }
    }
  }
}
</style>
<template>
  <div
    :class="canNotScroll ? 'preorder preorder-showLayer':'preorder'"
    ref="preorder"
    v-track="{act: 'ready', data: {id: 384}}"
  >
    <my-header :showHome="false" style="position:absolute" showBack></my-header>
    <div class="preorder">
      <div class="decorate"></div>
      <delivery-info :activeCode="activeCode"></delivery-info>
      <product-info :activeCode="activeCode"></product-info>
      <div class="group">
        <cards-item ref="cardsItem" :productsType="0" :thirdOrderId="thirdOrderId" v-if="isCardPay"></cards-item>
        <balance-item ref="balanceItem" :preorderId="this.preorderId" v-if="isBalancePay"></balance-item>
      </div>
      <sec-pwd-input
        ref="secPwdBox"
        v-if="showSecPwd"
        @code-value="codeVal"
        @close-box="closeSecPwd"
        :secPwd="secPwd"
        :secPwdMessage="secPwdMessage"
      ></sec-pwd-input>
      <div class="preorder-pay">
        <div class="need-pay">
          实付：
          <span>￥{{ needPay | price }}</span>
        </div>
        <div :class="`ensure-btn ${(canBuy && !isPaying)? '':'can-not-buy'}`" @click="toPay">确认</div>
      </div>
      <pay-type-select
        :price="needPay"
        :payOrderId="payOrderId"
        :activeCode="activeCode"
        v-if="showPayType"
        @close-type-select="closeTypeSelect"
      ></pay-type-select>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import _ from "underscore";
import op from "object-path";
import cookie from "../../lib/cookie.js";
import CONSTANT from "../../constant/preorder";
import CONSTANT_PAY from "../../constant/pay";
import CONSTANT_COOKIE from "../../constant/cookie.js";
import deliveryInfo from "./components/delivery_info";
import productInfo from "./components/product_info";
import payTypeSelect from "./components/pay_type_select";
import md5 from "MD5";
import { Toast, MessageBox } from "mint-ui";
import { getHostName, sessionStore } from "../../util/function.js";
import cloneDeep from "lodash.clonedeep";
import RSA from "../../util/RSA.js";
import myHeader from "../../components/header.vue";
import cardsItem from "./sub_view/cards_item.vue";
import secPwdInput from "./sub_view/sec_pwd_input.vue";
import couponItem from "./sub_view/coupon_item.vue";
import balanceItem from "./sub_view/balance_item.vue";
let rsa = new RSA();
const OVERTIME = "00:00";
export default {
  data() {
    return {
      canNotScroll: true,
      isShowPayItem: false,
      showPayType: false,
      isPaying: false,
      showSecPwd: false,
      secPwd: "", //安全密码
      secPwdMessage: "",
      oldOrderPrice:0
    };
  },
  components: {
    myHeader,
    deliveryInfo,
    productInfo,
    payTypeSelect,
    balanceItem,
    couponItem,
    cardsItem,
    secPwdInput
  },
  async mounted() {
    await this.initInformation();
    this.$store.commit("setOrderType", CONSTANT.PREORDER_ORDER_TYPE_NORMAL);
    this.$store.commit("setPreorderId", this.preorderId);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    if (!cookie(CONSTANT_COOKIE.COOKIE_USER_X_TOKEN)) {
      window.location.href = `${getHostName()}/mz-auth/#/connect/login?redirectUri=${getHostName()}/v5/#/preorder/${
        this.$route.params.key
      }/cash`;
    }
  },
  destroyed() {},
  watch: {
    secPwd(newVal, oldVal) {
      if (`${newVal}`.length > 0) {
        this.secPwdMessage = "";
      }
      if (`${newVal}`.length >= 6) {
        setTimeout(() => {
          this.toPay();
        }, 1000);
      }
    }
  },
  computed: {
    ...mapState({
      selectedBalance: state => state.preorder.selectedBalance,
      deliveryData: state => state.pay.deliveryData,
      selectedCards: state => state.preorder.selectedCards, //选择支付的卡
      totalPrice: state => state.pay.totalPrice || 0,
      skuListData: state => state.pay.skuListData || 0,
      isCardPay: state => state.preorder.payLimit.isCardPay == 0,
      isCouponPay: state => state.preorder.payLimit.isCouponPay == 0 && false, // FIXME: 暂时强制屏蔽现金券
      isBalancePay: state => state.preorder.payLimit.isBalancePay == 0,
      orderKey: state => state.preorder.orderKey, //电影订单的订单号或普通订单缓存key
      cardsDeduction: state =>
        op(state.preorder.selectedCards).get("deductionInfo.deductionValue") ||
        0,
      balanceDedcution: state => {
        return op(state.preorder.selectedBalance).get(
          "deductionInfo.deductionValue"
        ) && state.preorder.hasUsedBalance
          ? op(state.preorder.selectedBalance).get(
              "deductionInfo.deductionValue"
            )
          : 0;
      }
    }),
    express() {
      if (!this.expressSku) {
        return 0;
      }
      return this.expressSku.price * this.expressSku.count;
    },
    needPay: {
      get: function() {
        if(this.oldOrderPrice==0){
          return this.totalPrice - this.cardsDeduction - this.balanceDedcution;
        }else{
          return this.oldOrderPrice
        }
        
      },
      set: function(val) {
        
      }
    },
    canBuy() {
      if (
        !_.isEmpty(this.skuListData) &&
        this.totalPrice !== 0 &&
        !_.isEmpty(this.deliveryData)
      ) {
        return true;
      }
      return false;
    },
    activeCode() {
      return this.$route.params.activeCode;
    },
    preorderId() {
      return this.$route.params.key;
    },
    thirdOrderId() {
      return this.$route.params.key;
    },
    canUseBalance() {
      return (
        this.isBalancePay && this.amount !== 0
      ); /*  && (this.dedcutionPrice !== 0 || (this.deductiblePrice !== 0 && this.dedcutionPrice === 0)) */
    }
  },
  methods: {
    ...mapActions([
      "matchCardTotal",
      "checkUnPayOrder",
      "cancelUnPayOrder",
      "getSkuListByPreId",
      
      "getUnPayOrder",
      "createOrder",
      "orderOptimalPay",
      "getPayLimit"
    ]),
    setOrderInterval() {},
    focusInput() {},
    blurInput() {},
    codeVal(val) {
      this.secPwd = val;
    },
    async initInformation() {
      let self = this
          let key = this.preorderId

          if (!key) {
            return this.$router.go(-1)
          }

          if (key == this.orderKey) { //如果不是第一次进入该订单，无需再构造
            // this.setLogisticsMsg()
            return
          }

          this.canClick = false;
          this.$store.commit("clearAddress")
          this.$store.commit('initState')

          this.$store.commit("setOrderKey", key)
          // this.getAddressList()
          await this.initPayMethods()
          await this.initPreorderGoodsInfo()
          // this.setLogisticsMsg()
          this.canClick = true;
    },
    async initPreorderGoodsInfo() {
      let skusInfo = await this.getSkuListByPreId({
                preOrderId: this.orderKey
      })
      let skus = skusInfo.skuList
      this.$store.commit('setSkuListData', skus)
    },
    async initGoods(key) {},
    async initPayMethods() {
      let self = this;
      let data = {};
      let orderType = CONSTANT.PREORDER_ORDER_TYPE_NORMAL;

      let res = await this.getPayLimit({
        preOrderId: this.preorderId
      });

      if (res.isCardPay == 0 || res.isCouponPay == 0 || res.isBalancePay == 0) {
        self.initAssets({
          preOrderId: this.preorderId
        });
      }
    },
    async initAssets(data) {
      let cardNum = 0;
      let couponNum = 0;
      if (this.isCardPay) {
        this.matchCardTotal(data);
      }

      if (this.isCouponPay) {
        this.getOrderCouponNum(data);
      }

      await this.orderOptimalPay(data);
    },
    async IfHasOrder() {
      let data = await this.checkUnPayOrder({
        activeCode: this.activeCode
      });
      if (_.isEmpty(data)) {
        return false;
      }
      this.unPayOrder = data.payOrderId;
      return true;
    },
    checkInput() {},
    async toPay() {
      if (!this.canBuy || this.isPaying) {
        return;
      }
      this.isPaying = true;

      if (await this.IfHasOrder()) {
        this.toPayOldOrderOrNot();
        return;
      }

      this.startCreateOrder();
    },

    toPayOldOrderOrNot() {
      MessageBox({
        title: "提示",
        message: "您有一个未支付的订单，是否继续支付？",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "继续支付",
        cancelButtonText: "取消订单",
        confirmButtonHighlight: true,
        closeOnClickModal: false
      })
        .then(action => {
          if (action === "confirm") {
            // 继续支付
            this.getUnPayOrder({
              payOrderId: this.unPayOrder
            })
              .then(data => {
                this.oldOrderPrice = data.payAmount;
                this.payOrderId = data.payOrderId;
                this.showPayType = true;
                this.isPaying = false;
              })
              .catch(() => {
                this.isPaying = false;
              });
          } else {
            // 取消订单
            this.cancelUnPayOrder({
              payOrderId: this.unPayOrder
            })
              .then(() => {
                this.isPaying = false;
              })
              .catch(() => {
                this.isPaying = false;
              });
          }
        })
        .catch(() => {
          this.isPaying = false;
        });
    },
    startCreateOrder() {
      let data = this.payData();
      if (data === false) {
        return;
      }

      // var data = {
      //   isFromCart: 0,
      //   mobile: this.mobile,
      //   activeInfo: {
      //     activeCode: this.activeCode,
      //     brandActiveKey: this.brandActiveKey,
      //   },
      //   delivery: this.deliveryData,
      //   externalPayAmount: this.totalPrice,
      //   skuList: this.skuListData,
      // }
      this.createOrder(data)
        .then(data => {
          this.payOrderId = data.payOrderId;
          this.closeSecPwd();
          this.isPaying = false;
          this.showPayType = true;
          if (data.payAmount > 0) {
            return;
          }
          const url = `${getHostName()}/mz-act/pay/callback/${data.payOrderId}?activeCode=${this.activeCode}&payType=${CONSTANT_PAY.PAY_TYPE_NO_CASH}&rd=${+new Date()}`
          window.location.href=url
          // var url = `/activeCallback?payOrderId=${data.payOrderId}&activeCode=${this.activeCode}&payType=${CONSTANT_PAY.PAY_TYPE_NO_CASH}&rd=${+new Date()}`
          // this.$router.push({
          //   // path: `/preorder/${
          //   //   data.payOrderId
          //   // }/pay/callback/0?productType=0&orderType=${
          //   //   CONSTANT.PREORDER_ORDER_TYPE_NORMAL
          //   // }`
          //   path:url
          // });

        })
        .catch(err => {
          this.payError(err);
          // Toast({
          //   message: err.msg
          // });
          this.isPaying = false;
        });
    },
    closeTypeSelect() {
      this.showPayType = false;
    },
    payData() {
      let self = this;
      //填充卡数据
      let cards = [];
      _.each(op(this.selectedCards).get("epayList"), card => {
        let res = {
          type: 3, //识别方式为卡唯一码
          content: rsa.encrypt(card.epayId, "base64")
        };
        let skuList = [];
        _.each(card.deductionList, sku => {
          skuList.push({
            skuId: sku.skuId,
            epayAmount: sku.deductionValue,
            epayCount: sku.deductedCount
          });
        });
        res.skuList = skuList;
        cards.push(res);
      });
      // 填充余额数据
      let balance = [];
      if (this.balanceDedcution) {
        _.each(op(this.selectedBalance).get("epayList"), b => {
          let skuList = [];
          _.each(b.deductionList, sku => {
            skuList.push({
              skuId: sku.skuId,
              epayAmount: sku.deductionValue
            });
          });
          const res = {
            skuList
          };
          balance.push(res);
        });
      }
      /*  */
      let data = {
        remark: this.feedbackMsg,
        orderType: this.orderType,
        mobile: this.deliveryData.phone,
        delivery: this.deliveryData,
        externalPayAmount: this.needPay,
        ePaySign: [],
        ePayDetails: {}
      };
      /* 卡数据 */
      if (cards.length !== 0) {
        data.ePayDetails.cards = cards;
        data.ePaySign.push({
          sign: this.selectedCards.sign,
          type: 4
        });
      }

      if (balance.length !== 0) {
        data.ePayDetails.balances = balance;
        data.ePaySign.push({
          sign: this.selectedBalance.sign,
          type: 2
        });
      }

      /* 安全密码 */
      if (this.secPwd != "") {
        data.secPassword = md5(this.secPwd);
      }
      data.isFromCart = 0;

      data.skuList = this.skuListData;

     

      data.activeInfo = {
        activeCode: this.activeCode,
        groupCode: "",
        brandActiveKey:this.$route.query.brandActiveKey
      };
      if(this.$route.query.brandActiveKey){
          data.activeInfo.brandActiveKey = this.$route.query.brandActiveKey
      }

      return data;
    },
    payError(e) {
      this.canClick = true;
      if (e.status == 6603021) {
        this.secPwd = "";
        this.$refs.addresseeInfo.setErrorMsg(
          "所选商品超出配送范围，请核对您的地址"
        );
        // this.addressErrorMsg = '所选商品超出配送范围，请核对您的地址'
        return;
      }
      if (e.status == 6803009) {
        //未输入安全密码

        // 解决支付密码框样式在5s手机上的bug
        this.secPwd = "";
        this.showSecPwd = true;
        setTimeout(() => {
          this.$refs.secPwdBox.reset();
        }, 0);
        return;
      }

      if (e.status == 6803008) {
        // 未设置安全密码
        location.href = `${getHostName()}/mz-auth/#/user/security-code`;
        return;
      }
      if (e.status == 6803007) {
        //安全密码错误
        this.secPwdMessage = e.msg;
        this.secPwd = "";
        this.showSecPwd = true;
        setTimeout(() => {
          this.$refs.secPwdBox.reset();
        }, 0);
        return;
      }

      if (e.status == 6803010) {
        MessageBox.alert(e.msg).then(() => {
          this.secPwd = "";
          if (this.showSecPwd) {
            this.$refs.secPwdBox.reset();
            this.showSecPwd = false;
          }
        });
        return;
      }

      this.secPwd = "";
      if (this.showSecPwd) {
        this.$refs.secPwdBox.reset();
        this.showSecPwd = false;
      }
      Toast({
        message: e.msg,
        position: "bottom",
        duration: 3000
      });
    },
    async initFilm(data) {},
    closeSecPwd() {
      this.showSecPwd = false;
      this.secPwd = "";
    },
    async checkWechatFollow() {},
    closeFollowPage() {},
    cancelCashPay() {},
    showDeductionDetail() {},
    hideDeductionDetail() {}
  }
};
</script>
